import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { FormField } from '../../../components/FormFields';
import { Button } from '../../../components/Buttons';
import { Input } from '../../../components/Input';
import { Search, Times } from '../../../components/Icon';
import { changeInvoiceFilter } from '../actions';
import Dropdown from '../../../components/Dropdown/ReactDropdown';
import { SearchSelect } from '../../../components/SearchSelectComponent';

const Container = styled.div`
  .basic-multi-select {
    width: 100%;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class InvoiceSearchDirectionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE }, this.doSearch);
  }

  get options() {
    return [{ label: this.lbl(`invoice.direction.all`), value: null }].concat(
      ['incoming', 'outgoing'].map(value => ({
        label: this.lbl(`invoice.direction.${value}`),
        value,
      })),
    );
  }

  get value() {
    return this.options.find(o => o.value == this.props.filter.direction);
  }

  render() {
    return (
      <Container>
        <FormField>
          <SearchSelect options={this.options} value={this.value} onChange={pair => this.props.setValue(pair.value)} />
        </FormField>
      </Container>
    );
  }
}

InvoiceSearchDirectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(string) {
      dispatch(changeInvoiceFilter('direction', string));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoiceSearchDirection = compose(withConnect, withRouter, injectIntl)(InvoiceSearchDirectionComp);
